<template>
<div>
  <div class="modal is-active is-sticky-right silo-reports-checkout-modal">
    <div class="modal-background" @click.stop="$emit('close')"></div>
    <div class="modal-content co-modal-wrap">
      <div class="box modal-container mainColor--text co-modal-container">
        <div class="co-modal-inner">
        <div class="main-part">
          <div class="left-part">
            <div class="form-part">

              <template v-if="isEditMode">
                <div class="co-page-header">
                  <a href="#" class="co-back-link mb-4" @click.prevent="$emit('close')">
                    <i class="material-icons" style="font-size: 18px;">arrow_back</i>
                    Back to {{ displayProjectTitle }}
                  </a>
                  <div class="co-page-title">Order content</div>
                  <div class="co-page-sub mb-8">Configure your content order and choose delivery options</div>
                </div>

                <div style="border: 1px solid #DADADA; border-radius: 12px; padding: 20px;">
                  <div class="steps-bar">
                    <div
                      v-if="topLevelKeywords.length"
                      :class="['co-step-tab', { active: step === 0, completed: step > 0 }]"
                      @click="step = 0"
                    >Top-level pages</div>
                    <div
                      v-if="supportingKeywords.length"
                      :class="['co-step-tab', { active: step === 1, completed: step > 1 }]"
                      @click="step = 1"
                    >Supporting pages</div>
                    <div
                      :class="['co-step-tab', { active: step === 2, completed: step > 2 }]"
                      @click="step = 2"
                    >Configuration</div>
                    <div
                      :class="['co-step-tab', { active: step === 3, completed: step > 3 }]"
                      @click="step = 3"
                    >Delivery &amp; checkout</div>
                  </div>
  
                  <div v-if="step === 0 && topLevelKeywords.length">
                    <div class="co-reco-head">
                      <div class="co-reco-h">Answer a few questions to get the best product recommendation</div>
                      <div class="co-reco-sub">We’ll suggest the right content type based on your answers.</div>
                    </div>
  
                    <div
                      v-for="(row, idx) in topCompletedWizardRows"
                      :key="'tw-' + idx"
                      class="co-wizard-done"
                    >
                      <div class="co-badge-num">{{ idx + 1 }}</div>
                      <div class="co-wizard-q">{{ row.questionText }}</div>
                      <div class="co-wizard-ans">
                        <span class="co-ans-text">{{ row.answerLabel }}</span>
                        <span class="co-change" @click="topWizardChangeFromRow(idx)">Change</span>
                      </div>
                    </div>
  
                    <div v-if="topActiveQuestionDef" class="co-wizard-active">
                      <div class="co-wizard-active-head">
                        <div class="co-badge-num is-active">{{ topWizardBadgeNumber }}</div>
                        <div class="co-wizard-q">{{ topActiveQuestionDef.text }}</div>
                      </div>
                      <div class="co-option-cards">
                        <div
                          v-for="opt in topActiveQuestionDef.options"
                          :key="String(opt.value)"
                          class="co-option-card"
                          @click="topWizardPickOption(opt.value)"
                        >
                          <div class="co-oc-title">{{ opt.label }}</div>
                          <div class="co-oc-sub">{{ opt.sublabel }}</div>
                        </div>
                      </div>
                    </div>
  
                    <template v-if="!topActiveQuestionDef">
                      <div class="co-product-section-title">Your recommended content type</div>
                      <div class="co-section-sub">Based on your answers, here's what we recommend — but you can pick any option.</div>
                      <div class="silo-report-cards-list">
                        <div
                          v-for="report in AVAILAIBLE_TOP_LEVEL_SILO_REPORTS" :key="report.key"
                          :class="['silo-report-card', {
                            selected: report.key === order.selected_top_level_option_key,
                            'is-recommended': topResolvedRecommendationKey && report.key === topResolvedRecommendationKey
                          }]"
                          @click="selectTopLevelPackage(report.key)"
                        >
                          <span
                            v-if="topResolvedRecommendationKey && report.key === topResolvedRecommendationKey"
                            class="co-reco-pill"
                          >Recommended</span>
                          <div class="mb-2"><span class="font-weight-bold" style="font-size: 1.25rem;">${{ report.price }}</span></div>
                          <div class="mb-2"><span class="font-weight-bold">{{ report.label }}</span></div>
                          <div class="co-oc-sub" v-if="report.description_html" v-html="report.description_html"></div>
                          <div class="co-oc-sub" v-else>{{ report.description }}</div>
                        </div>
                      </div>
                    </template>
  
                    <div class="co-keywords-head">Top-level pages you’ve selected</div>
                    <div
                      v-for="keyword in topLevelKeywords.slice(0, showAllTopLevelKeywords ? topLevelKeywords.length : 4)"
                      :key="keyword.id"
                      class="keyword-row"
                    >
                      <div class="keyword-data">
                        <span class="font-weight-bold">{{ keyword.keyword }}</span>
                      </div>
                      <div class="co-kw-price" v-if="selectedTopLevelOption && !topActiveQuestionDef">{{ formatCurrency(selectedTopLevelOption.price) }}</div>
                      <div class="action" v-if="keywords?.length && keywords?.length > 1">
                        <v-btn icon small color="red" @click="removeKeyword(keyword)">
                          <img src="/static/red_trash_icon.svg">
                        </v-btn>
                      </div>
                    </div>
                    <a
                      v-if="topLevelKeywords.length > 4"
                      href="#"
                      class="supporting-pages-toggle"
                      @click.prevent="showAllTopLevelKeywords = !showAllTopLevelKeywords"
                    >
                      {{ showAllTopLevelKeywords ? 'Show less' : '+ Show all pages…' }}
                    </a>
                  </div>
  
                  <div v-else-if="step === 1 && supportingKeywords.length">
                    <div class="co-reco-head">
                      <div class="co-reco-h">Answer a few questions to get the best product recommendation</div>
                      <div class="co-reco-sub">We’ll suggest the right content type based on your answers.</div>
                    </div>
  
                    <div
                      v-for="(row, idx) in supCompletedWizardRows"
                      :key="'sw-' + idx"
                      class="co-wizard-done"
                    >
                      <div class="co-badge-num">{{ idx + 1 }}</div>
                      <div class="co-wizard-q">{{ row.questionText }}</div>
                      <div class="co-wizard-ans">
                        <span class="co-ans-text">{{ row.answerLabel }}</span>
                        <span class="co-change" @click="supWizardChangeFromRow(idx)">Change</span>
                      </div>
                    </div>
  
                    <div v-if="supActiveQuestionDef" class="co-wizard-active">
                      <div class="co-wizard-active-head">
                        <div class="co-badge-num is-active">{{ supWizardBadgeNumber }}</div>
                        <div class="co-wizard-q">{{ supActiveQuestionDef.text }}</div>
                      </div>
                      <div class="co-option-cards">
                        <div
                          v-for="opt in supActiveQuestionDef.options"
                          :key="String(opt.value)"
                          class="co-option-card"
                          @click="supWizardPickOption(opt.value)"
                        >
                          <div class="co-oc-title">{{ opt.label }}</div>
                          <div class="co-oc-sub">{{ opt.sublabel }}</div>
                        </div>
                      </div>
                    </div>
  
                    <template v-if="!supActiveQuestionDef">
                      <div class="co-product-section-title">Choose your content type for supporting pages</div>
                      <div class="co-section-sub">{{ AVAILAIBLE_SUPPORTING_SILO_REPORTS.length }} options available for supporting pages.</div>
                      <div class="silo-report-cards-list">
                        <div
                          v-for="report in AVAILAIBLE_SUPPORTING_SILO_REPORTS" :key="report.key"
                          :class="['silo-report-card', {
                            selected: report.key === order.selected_supporting_option_key,
                            'is-recommended': supportingResolvedRecommendationKey && report.key === supportingResolvedRecommendationKey
                          }]"
                          @click="updateOrder({ selected_supporting_option_key: report.key })"
                        >
                          <span
                            v-if="supportingResolvedRecommendationKey && report.key === supportingResolvedRecommendationKey"
                            class="co-reco-pill"
                          >Recommended</span>
                          <div class="mb-2"><span class="font-weight-bold" style="font-size: 1.25rem;">${{ report.price }}</span></div>
                          <div class="mb-2"><span class="font-weight-bold">{{ report.label }}</span></div>
                          <div class="co-oc-sub" v-if="report.description_html" v-html="report.description_html"></div>
                          <div class="co-oc-sub" v-else>{{ report.description }}</div>
                        </div>
                      </div>
                    </template>
  
                    <div class="co-keywords-head">Supporting pages you’ve selected</div>
                    <div
                      v-for="keyword in supportingKeywords.slice(0, showAllSupportingKeywords ? supportingKeywords.length : 4)"
                      :key="keyword.id"
                      class="keyword-row"
                    >
                      <div class="keyword-data">
                        <span class="font-weight-bold">{{ keyword.keyword }}</span>
                      </div>
                      <div class="co-kw-price" v-if="selectedSupportingOption && !supActiveQuestionDef">{{ formatCurrency(selectedSupportingOption.price) }}</div>
                      <div class="action" v-if="keywords?.length && keywords?.length > 1">
                        <v-btn icon small color="red" @click="removeKeyword(keyword)">
                          <img src="/static/red_trash_icon.svg">
                        </v-btn>
                      </div>
                    </div>
                    <a
                      v-if="supportingKeywords.length > 4"
                      href="#"
                      class="supporting-pages-toggle"
                      @click.prevent="showAllSupportingKeywords = !showAllSupportingKeywords"
                    >
                      {{ showAllSupportingKeywords ? 'Show less' : '+ Show all pages…' }}
                    </a>
                  </div>
  
                  <div v-else-if="step === 2">
  
                    <div class="co-wizard-active mb-6">
                      <div class="co-wizard-active-head">
                        <div>
                          <div class="co-wizard-q mb-2">Content approach</div>
                          <div style="color: #6A6A6A;">How would you like us to handle the writing?</div>
                        </div>
                      </div>
                      <div class="co-config-cards">
                        <div
                          :class="['co-config-card', { 'is-selected': order.content_configuration_type === 'creative' }]"
                          @click="updateOrder({ content_configuration_type: 'creative' })"
                        >
                          <v-radio
                            hide-details
                            class="ma-0 pa-0"
                            color="profileAnchorColor"
                            :input-value="order.content_configuration_type === 'creative'"
                            @click.native.prevent.stop="updateOrder({ content_configuration_type: 'creative' })"
                          />
                          <div class="co-cc-body">
                            <div class="co-cc-title">Let our team handle everything</div>
                            <div class="co-cc-sub">We make all writing and style decisions.</div>
                          </div>
                        </div>
                        <div
                          :class="['co-config-card', { 'is-selected': order.content_configuration_type === 'custom' }]"
                          @click="updateOrder({ content_configuration_type: 'custom' })"
                        >
                          <v-radio
                            hide-details
                            class="ma-0 pa-0"
                            color="profileAnchorColor"
                            :input-value="order.content_configuration_type === 'custom'"
                            @click.native.prevent.stop="updateOrder({ content_configuration_type: 'custom' })"
                          />
                          <div class="co-cc-body">
                            <div class="co-cc-title">Help us match your vision</div>
                            <div class="co-cc-sub">Share preferences to match your brand.</div>
                          </div>
                        </div>
                      </div>
                    </div>
  
                    <div v-if="order.content_configuration_type === 'custom'">
                      <b-collapse
                        class="configs-collapsible card"
                        animation="slide"
                        v-for="(item, index) in configComponents"
                        :key="`Config${item.key}`"
                        :open="isOpenCustomConfig === index"
                        @open="isOpenCustomConfig = index"
                      >
                        <template #trigger="props">
                            <div
                                class="card-header"
                                role="button"
                                :aria-controls="'contentIdForA11y5-' + index"
                                :aria-expanded="props.open"
                            >
                                <div class="card-header-title">
                                    <div class="config-left">
                                      <span>{{ item.label }}</span>
                                      <span v-if="item.required" class="required-label">
                                        Required
                                      </span>
                                    </div>
  
                                    <component
                                      :is="`ConfigPreview${item.key}`"
  
                                      :productDescription="productDescription"
                                      :targetAudience="targetAudience"
                                      :sampleContent="sampleContent"
                                      :toneOfContent="toneOfContent"
                                      :author="author"
                                      :brand="brand"
                                      :excludeTerms="excludeTerms"
                                    />
  
                                </div>
                                <a class="card-header-icon">
                                  <i class="material-icons-outlined">{{ props.open ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</i>
                                </a>
                            </div>
                        </template>
                        <div class="card-content">
                            <div class="content">
                                <component
                                  :is="`Config${item.key}`"
                                  
                                  :countWords="countWords"
  
                                  :productDescription.sync="productDescription"
  
                                  :targetAudience.sync="targetAudience"
  
                                  :sampleContent.sync="sampleContent"
  
                                  :toneOfContent.sync="toneOfContent"
                                  :author.sync="author"
                                  :brand.sync="brand"
  
                                  :excludeTerms.sync="excludeTerms"
                                  :addNewExcludeTerm="addNewExcludeTerm"
                                  :handleRemoveExcludeTerm="handleRemoveExcludeTerm"
  
                                />
                            </div>
                        </div>
                      </b-collapse>
                    </div>
  
                    <div
                      v-if="(
                        (topLevelKeywords.length && order.selected_top_level_option_key !== 'TOP_LEVEL_CONTENT_UPGRADE')
                        || (supportingKeywords.length)
                      )"
                      class="co-ai-block"
                    >
                      <div class="co-ai-toggle-row">
                        <div class="co-ai-toggle-label">Include AI-generated images</div>
                        <v-switch
                          inset
                          hide-details
                          dense
                          color="#fff"
                          :input-value="aiImagesAnyEnabled"
                          @change="setAiImagesMaster($event)"
                        />
                      </div>
                      <div class="co-section-sub" style="margin-bottom: 8px;">Choose a visual style for images in your articles.</div>
                      <div class="co-style-pills">
                        <button
                          v-for="pill in aiImageStyleOptionsList"
                          :key="pill.value"
                          type="button"
                          :class="['co-style-pill', {
                            'is-selected': order.aiGeneratedImageStyle === pill.value,
                            'is-disabled': !aiImagesAnyEnabled
                          }]"
                          @click="selectImageStyle(pill.value)"
                        >
                          {{ pill.label }}
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <div v-else-if="step === 3">
                    <div class="co-section-title">Delivery time &amp; checkout</div>
                    <div class="co-section-sub">You can have up to 3 orders per delivery period.</div>
  
                    <b-dropdown aria-role="list" class="delivery-period-dropdown">
                      <template #trigger>
                        <b-button
                          class="delivery-period-dropdown-button"
                          :label="
                            nonSpeedyDeliveryPeriods.includes(order.delivery_period_days)
                              ? ALLOWED_SILO_ORDER_DELIVERY_PERIODS[order.delivery_period_days].label
                              : 'Choose delivery period'
                          "
                          icon-right="angle-down"
                        />
                      </template>
  
                      <b-dropdown-item custom aria-role="menuitem">
                        <span class="font-weight-bold mainColor--text">Select period</span>
                      </b-dropdown-item>
  
                      <b-dropdown-item
                        v-for="option in nonSpeedyDeliveryPeriods"
                        :key="option"
                        aria-role="listitem"
                        :disabled="!availableDeliveryPeriodsForSite.includes(option) && order.delivery_period_days !== option"
                        @click="updateOrder({ delivery_period_days: option })"
                      >
                        <b-icon
                          :icon="order.delivery_period_days === option ? 'check' : ''"
                          type="is-success"
                          size="is-small"
                        />
                        {{ `${ALLOWED_SILO_ORDER_DELIVERY_PERIODS[option].label}` + (!availableDeliveryPeriodsForSite.includes(option) && order.delivery_period_days !== option ? ' (Unavailable)' : '') }}
                      </b-dropdown-item>
                    </b-dropdown>
  
                    <div class="co-delivery-rush">
                      <v-checkbox
                        class="silo-order-form-checkbox ma-0 mb-2"
                        color="success"
                        off-icon="none"
                        on-icon="check"
                        :ripple="false"
                        hide-details
                        style="margin-left: -10px !important;"
                        :input-value="order.delivery_period_days === SILO_ORDER_SPEEDY_DELIVERY_PERIOD"
                        @change="updateOrder({
                          delivery_period_days: $event ? SILO_ORDER_SPEEDY_DELIVERY_PERIOD : null
                        })"
                      >
                        <template v-slot:label>
                          <div>
                            <div>Rush delivery — 72 hours</div>
                          </div>
                        </template>
                      </v-checkbox>
                      <div class="co-oc-sub mb-2" style="color: #6A6A6A;">Get content in 3 days instead of standard.</div>
                      <div class="co-rush-pct">+{{ SILO_ORDER_SPEEDY_DELIVERY_MULTIPLIER * 100 }}% to total</div>
                    </div>
                  </div>
                </div>
                
              </template>
              
              <template v-if="order?.order_status === 'in_checkout'">
                In checkout
              </template>

              <template v-if="['in_cart', 'in_cart_checkout'].includes(order?.order_status)">
                Order was added to cart.
                <br /><br />
                <a href="#" @click.prevent="$store.commit('setShowSiloContentReportsOrdersCart', true); $emit('close');">Open cart</a>
              </template>

            </div>
            <div class="form-controls-part">
              <template v-if="isEditMode">
                <div>
                  <v-btn
                    v-if="step > (topLevelKeywords.length ? 0 : 1)"
                    rounded
                    outlined
                    class="co-btn-prev text-none"
                    @click="goBack"
                  >
                    <i class="material-icons" style="margin-right: 6px;">arrow_back</i>
                    <span>Previous step</span>
                  </v-btn>
                </div>
                <div class="d-flex align-center gap15">
                  <v-btn
                    v-if="step < 3"
                    rounded
                    color="profileAnchorColor"
                    class="co-btn-next text-none whiteColor--text"
                    :disabled="!isStepValid(step)"
                    @click="goToNextStep"
                  >
                    <span>Next step</span>
                    <i class="material-icons" style="margin-left: 6px;">arrow_forward</i>
                  </v-btn>
                </div>
              </template>
              <template v-else-if="['in_checkout', 'in_cart'].includes(order?.order_status)">
                <div>
                  <v-btn
                    rounded
                    outlined
                    class="text-none"
                    @click="updateOrder({set_user_editing: true})"
                  >
                    <i class="material-icons" style="margin-right: 10px;">arrow_back</i>
                    <span>Edit</span>
                  </v-btn>
                </div>
              </template>
            </div>
          </div>
          <div class="right-part">
            <div class="co-summary-sticky">
              <div class="co-summary-header">
                <div class="co-summary-title">Order summary</div>
                <div class="co-summary-sub">{{ displayProjectTitle }}</div>
              </div>
              <div class="co-summary-body">
                <div class="co-summary-meta">
                  <span>{{ orderArticleCount }} articles</span>
                  <span class="text-right" style="max-width: 55%;">{{ orderSummaryProductLabel }}</span>
                </div>
                <ul class="co-summary-lines">
                  <li
                    v-for="line in orderSummaryLineItems"
                    :key="line.id"
                    class="co-summary-line"
                  >
                    <span class="co-sl-kw">{{ line.keyword }}</span>
                    <span class="co-sl-price">{{ line.price != null ? formatCurrency(line.price) : '—' }}</span>
                  </li>
                </ul>
                <div
                  v-if="order.delivery_period_days === SILO_ORDER_SPEEDY_DELIVERY_PERIOD"
                  class="co-summary-line"
                >
                  <span class="co-sl-kw">Rush delivery ({{ SILO_ORDER_SPEEDY_DELIVERY_MULTIPLIER * 100 }}%)</span>
                  <span class="co-sl-price">{{ formatCurrency(speedyDeliveryAmount) }}</span>
                </div>
                <div
                  v-if="(!isEditMode || step > 2) && appliedCoupon && appliedCoupon.coupon"
                  class="co-summary-line"
                  style="border-bottom: none;"
                >
                  <span class="co-sl-kw">Coupon</span>
                  <span class="co-sl-price">
                    {{ appliedCoupon.coupon.couponType === 'Amount Off' ? '$' : '' }}{{ appliedCoupon.coupon.amountOff }}{{ appliedCoupon.coupon.couponType === 'Percent Off' ? '%' : '' }} off
                  </span>
                </div>
                <div
                  v-if="(!isEditMode || step > 2) && user.is_eligible_for_first_content_order_discount"
                  class="co-summary-line"
                >
                  <span class="co-sl-kw">First order discount</span>
                  <span class="co-sl-price">${{ FIRST_CONTENT_ORDER_AMOUNT_OFF }}</span>
                </div>
                <div v-if="!isEditMode || step > 2" class="co-summary-divider" />
                <div v-if="!isEditMode || step > 2" class="co-summary-total">
                  <span>Total</span>
                  <span>{{ formatCurrency(totalAmount) }}</span>
                </div>
                <div v-if="!isEditMode || step > 2" class="co-summary-note">
                  {{ orderSummaryDeliveryNote }}
                </div>

                <!--
                <div v-if="isEditMode && step === 0 && supportingKeywords.length && topLevelKeywords.length" class="mt-2">
                  <v-btn text x-small color="red" @click="bulkRemoveKeywords('T')">Remove all top-level</v-btn>
                </div>
                <div v-if="isEditMode && step === 1 && topLevelKeywords.length && supportingKeywords.length" class="mt-2">
                  <v-btn text x-small color="red" @click="bulkRemoveKeywords('S')">Remove all supporting</v-btn>
                </div>
                -->
              </div>

              <template v-if="isEditMode && step === 3">
                <div class="co-summary-actions">

                  <v-btn
                    rounded
                    outlined
                    block
                    class="co-btn-add-to-cart"
                    :disabled="!isStepValid(3) || !!appliedCoupon || user.is_eligible_for_first_content_order_discount"
                    @click="updateOrder({ set_in_cart: true })"
                  >
                    Add to cart &amp; select more silos
                  </v-btn>
                  <template v-if="isMissionControlSession">
                    <v-btn
                      rounded
                      color="profileAnchorColor"
                      class="button-with-icon text-none whiteColor--text padding8 height38"
                      block
                      tag="a"
                      :disabled="!isStepValid(3)"
                      @click="showSendInvoiceConfirmModal = true"
                    >
                      <i class="material-icons-outlined" style="margin-right: 10px; font-size: 1.2rem;">shopping_basket</i>
                      Send invoice to user - {{ formatCurrency(totalAmount) }}
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn
                      v-if="ownerUser?.balance_cents < (totalAmount * 100)"
                      rounded
                      color="profileAnchorColor"
                      class="whiteColor--text"
                      block
                      :disabled="!isStepValid(3) || isMissionControlSession"
                      @click="buyNow()"
                    >
                      <i class="material-icons" style="font-size: 18px; margin-right: 6px;">shopping_cart</i>
                      Place order — {{ formatCurrency(totalAmount) }}
                    </v-btn>
                    <b-dropdown
                      v-else
                      aria-role="list"
                      @click.native.stop
                      position="is-top-right"
                      class="place-order-dropdown"
                      :disabled="!isStepValid(3) || isMissionControlSession"
                    >
                      <template #trigger>
                        <v-btn
                          rounded
                          block
                          color="profileAnchorColor"
                          class="whiteColor--text"
                        >
                          <i class="material-icons" style="font-size: 18px; margin-right: 6px;">shopping_cart</i>
                          Place order — {{ formatCurrency(totalAmount) }}
                        </v-btn>
                      </template>
                      <b-dropdown-item aria-role="listitem" @click.native.stop="buyNow()">Pay with credit card</b-dropdown-item>
                      <b-dropdown-item aria-role="listitem" @click.native.stop="showBalancePaymentConfirmModal = true">Pay with balance</b-dropdown-item>
                    </b-dropdown>
                  </template>

                  <v-btn
                    v-if="isMissionControlSession"
                    rounded
                    color="profileAnchorColor"
                    class="button-with-icon text-none whiteColor--text mb-6"
                    href="#" @click.prevent="showSetPaidConfirmModal = true"
                  >Set as paid</v-btn>

                </div>

                
                <div
                  v-if="!user.is_eligible_for_first_content_order_discount"
                  class="co-apply-coupon"
                >
                  <a
                    v-if="!sidebarCouponExpanded && !(appliedCoupon && appliedCoupon.coupon)"
                    href="#"
                    @click.prevent="sidebarCouponExpanded = true"
                  >Apply a coupon</a>
                  <span
                    v-if="appliedCoupon && appliedCoupon.coupon"
                    style="color: #316BFF; font-size: 0.875rem; font-weight: 600;"
                  >
                    <i class="material-icons" style="font-size: 16px; vertical-align: text-bottom;">check</i>
                    Coupon applied
                  </span>
                </div>
                <div
                  v-if="sidebarCouponExpanded && !(appliedCoupon && appliedCoupon.coupon) && !user.is_eligible_for_first_content_order_discount"
                  class="co-coupon-inline"
                >
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    v-model="modalCouponFieldValue"
                    placeholder="Enter coupon"
                    color="grayColor"
                    class="mb-2"
                  />
                  <v-btn
                    block
                    color="profileAnchorColor"
                    class="whiteColor--text text-none"
                    :disabled="!modalCouponFieldValue"
                    @click="applyCoupon()"
                  >
                    Apply coupon
                  </v-btn>
                </div>

                <b-dropdown
                  v-if="isWhiteGloveUser && isMissionControlSession && order"
                  aria-role="list"
                  class="sales-tag-dropdown"
                  @click.native.stop
                  position="is-top-right"
                  style="align-self: center;"
                >
                  <template #trigger>
                    <v-btn
                      block
                      outlined
                      class="sales-tag-btn mb-1"
                      small
                      :color="order.sales_tag === 'active' ? 'success' : undefined"
                    >
                      <template v-if="order.sales_tag === 'passive'">Passive sale</template>
                      <template v-else-if="order.sales_tag === 'active'">Active sale</template>
                      <template v-else-if="!order.sales_tag">Sales tag</template>
                      <template v-else>{{ order.sales_tag }}</template>
                    </v-btn>
                  </template>
                  <b-dropdown-item :disabled="order.sales_tag === 'passive'" aria-role="listitem" @click.native.stop="updateOrder({ sales_tag: 'passive' })">Set as passive sale</b-dropdown-item>
                  <b-dropdown-item :disabled="order.sales_tag === 'active'" aria-role="listitem" @click.native.stop="updateOrder({ sales_tag: 'active' })">Set as <b>active sale</b></b-dropdown-item>
                </b-dropdown>
              </template>

              <div class="co-balance-box">
                Payment from {{ $store.getters.whiteGloveFamilyProgramName }} Balance.
                <div>Current: <b>{{ formatCurrency(ownerUser.balance_cents / 100) }}</b></div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="showBalancePaymentConfirmModal"
    class="modal"
    :class="{
      'is-active': true,
    }"
  >
    <div
      class="modal-background"
      @click="
        showBalancePaymentConfirmModal = false
      "
    ></div>
    <div class="modal-content">
      <div class="box modal-container">
        <div class="pad10">
          <div>
            <div
              class="mainColor--text font-weight-bold mb-5"
              style="font-size: 20px"
            >
              Confirm payment
            </div>
            <div
              class="mainColor--text mb-5"
              style="font-size: 16px; line-height: 24px"
            >
              You’re about to use <b>{{ formatCurrency(totalAmount) }}</b> from your {{ $store.getters.whiteGloveFamilyProgramName }} balance to order content from your POP team. This amount will be deducted immediately from your available balance.
            </div>
          </div>

          <div class="d-flex align-center justify-space-between gap10">
            <div
              class="mainColor--text"
              style="font-size: 16px; line-height: 24px; font-weight: 700;"
            >
              Current balance: {{ formatCurrency(this.ownerUser.balance_cents / 100) }}
            </div>
            <div class="text-right">
              <v-btn
                outlined
                color="mainColor"
                class="button-with-icon mainColor--text text-none ml-2"
                @click="
                  () => {
                    showBalancePaymentConfirmModal = false;
                  }
                "
              >
                <span>Cancel</span>
              </v-btn>
              <v-btn
                color="profileAnchorColor"
                class="button-with-icon whiteColor--text text-none ml-2"
                @click="buyNow('balance')"
              >
                <span>Confirm & order</span>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="showSendInvoiceConfirmModal && isMissionControlSession"
    class="modal"
    :class="{
      'is-active': true,
    }"
  >
    <div
      class="modal-background"
      @click="showSendInvoiceConfirmModal = false"
    ></div>
    <div class="modal-content">
      <div class="box modal-container">
        <div class="pad25">
          <div>
            <div
              class="mainColor--text font-weight-bold mb-5"
              style="font-size: 20px"
            >
              Are you sure?
            </div>
            <div
              class="mainColor--text mb-5"
              style="font-size: 16px; line-height: 24px"
            >
              You are about to send an invoice by email to the site owner's billing email (<b style="font-size: 16px; line-height: 24px">{{ selectedSubAccountRelation?.agencyInvoicingEmail || selectedSubAccountRelation?.agencyUserEmail }}</b>) for this {{ $store.getters.whiteGloveFamilyProgramName }} content order.
              <br /><br />
              Are you sure you want to proceed?
            </div>
          </div>
          <div class="text-right">
            <v-btn
              rounded
              color="profileAnchorColor"
              class="button-with-icon whiteColor--text text-none ml-2"
              @click="buyNow('invoice')"
            >
              <span>Yes, send invoice - {{ formatCurrency(totalAmount) }}</span>
            </v-btn>
            <v-btn
              rounded
              outlined
              color="mainColor"
              class="button-with-icon mainColor--text text-none ml-2"
              @click="showSendInvoiceConfirmModal = false"
            >
              <span>Cancel</span>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div
    v-if="isSubAccountRelationSelected"
    class="modal"
    :class="{ 'is-active': showSubAccountNotAllowedToBuyModal }"
  >
    <div
      class="modal-background"
      @click="showSubAccountNotAllowedToBuyModal = false"
    ></div>
    <div class="modal-content">
      <div class="box modal-container">
        <div class="modal-content-root">
          <div class="subtitle-font mainColor--text mb-3" style="font-size: 1.2rem; font-weight: 700;">
            You can’t place orders
          </div>
          <div class="subtitle-font mainColor--text mb-5" style="line-height: 1.5;">
            Only the main account has permission to create orders. Please contact your account admin ({{ selectedSubAccountRelation.agencyUserEmail }}) if you need help.
          </div>
          <div class="text-right">
            <v-btn
              rounded
              color="profileAnchorColor"
              class="button-with-icon whiteColor--text text-none"
              @click="showSubAccountNotAllowedToBuyModal = false"
            >
              Ok
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <button class="custom-modal-close-btn" aria-label="close" @click="showSubAccountNotAllowedToBuyModal = false"><i class="material-icons" style="font-size: 1.7rem;">close</i></button>
  </div>

  <div
    v-if="showSetPaidConfirmModal && isMissionControlSession"
    class="modal"
    :class="{
      'is-active': true,
    }"
  >
    <div
      class="modal-background"
      @click="
        showSetPaidConfirmModal = false
      "
    ></div>
    <div class="modal-content">
      <div class="box modal-container">
        <div class="pad25">
          <div>
            <div
              class="mainColor--text font-weight-bold mb-5"
              style="font-size: 20px"
            >
              Are you sure?
            </div>
            <div
              class="mainColor--text mb-5"
              style="font-size: 16px; line-height: 24px"
            >
              This will set mark the order as paid and create Asana tasks.
            </div>
          </div>
          <div class="text-right">
            <v-btn
              rounded
              color="profileAnchorColor"
              class="button-with-icon whiteColor--text text-none ml-2"
              @click="$store.commit('showLoading'); updateOrder({set_paid: 1}).finally(() => {$store.commit('hideLoading'); showSetPaidConfirmModal = false})"
            >
              <span>Yes, proceed</span>
            </v-btn>
            <v-btn
              rounded
              outlined
              color="mainColor"
              class="button-with-icon mainColor--text text-none ml-2"
              @click="
                () => {
                  showSetPaidConfirmModal = false;
                }
              "
            >
              <span>Cancel</span>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { getPureServicePkgName, formatCurrency } from '@/utils';
import {
  whiteGlovePlans,
  ALLOWED_SILO_ORDER_DELIVERY_PERIODS,
  SILO_ORDER_SPEEDY_DELIVERY_PERIOD,
  SILO_ORDER_SPEEDY_DELIVERY_MULTIPLIER,
  FIRST_CONTENT_ORDER_AMOUNT_OFF
} from "@/components/plans_constants"


import ConfigProductDescription from "@/components/Campaigns/content-orders/ContentOrderForm/configs/product-description/ConfigProductDescription.vue";
import ConfigPreviewProductDescription from "@/components/Campaigns/content-orders/ContentOrderForm/configs/product-description/ConfigPreviewProductDescription.vue";

import ConfigSampleContent from "@/components/Campaigns/content-orders/ContentOrderForm/configs/sample-content/ConfigSampleContent.vue";
import ConfigPreviewSampleContent from "@/components/Campaigns/content-orders/ContentOrderForm/configs/sample-content/ConfigPreviewSampleContent.vue";

import ConfigTargetAudience from "@/components/Campaigns/content-orders/ContentOrderForm/configs/target-audience/ConfigTargetAudience.vue";
import ConfigPreviewTargetAudience from "@/components/Campaigns/content-orders/ContentOrderForm/configs/target-audience/ConfigPreviewTargetAudience.vue";

import ConfigTone from "@/components/Campaigns/content-orders/ContentOrderForm/configs/tone/ConfigTone.vue";
import ConfigPreviewTone from "@/components/Campaigns/content-orders/ContentOrderForm/configs/tone/ConfigPreviewTone.vue";

import ConfigExcludeTerms from "@/components/Campaigns/content-orders/ContentOrderForm/configs/exclude-terms/ConfigExcludeTerms.vue";
import ConfigPreviewExcludeTerms from "@/components/Campaigns/content-orders/ContentOrderForm/configs/exclude-terms/ConfigPreviewExcludeTerms.vue";

import {
  QUESTIONS,
  createEmptyTopWizardState,
  createEmptySupportingWizardState,
  getActiveTopQuestionId,
  getActiveSupportingQuestionId,
  getCompletedTopRows,
  getCompletedSupportingRows,
  computeTopLevelPackageKey,
  computeSupportingPackageKey,
  resetTopWizardFromStep,
  resetSupportingWizardFromStep,
} from './contentProductRecommendation';

const AI_IMAGE_STYLE_OPTIONS = [
  { value: 'photo_realistic', label: 'Photo-realistic' },
  { value: 'illustrative', label: 'Illustrative' },
  { value: 'infographic', label: 'Infographic' },
  { value: 'brand_text', label: 'Brand & text' },
  { value: 'product_focused', label: 'Product-focused' },
];

const configComponents = [
  {
    label: 'Product or service description',
    key: 'ProductDescription',
    component: ConfigProductDescription,
    previewComponent: ConfigPreviewProductDescription,
  },
  {
    label: 'Target audience',
    key: 'TargetAudience',
    component: ConfigTargetAudience,
    previewComponent: ConfigPreviewTargetAudience,
  },
  {
    label: 'Tone of voice',
    key: 'Tone',
    component: ConfigTone,
    previewComponent: ConfigPreviewTone,
  },
  {
    label: 'Sample content',
    key: 'SampleContent',
    component: ConfigSampleContent,
    previewComponent: ConfigPreviewSampleContent,
  },
  {
    label: 'Exclude specific words',
    key: 'ExcludeTerms',
    component: ConfigExcludeTerms,
    previewComponent: ConfigPreviewExcludeTerms,
  },
]

const defaultOrderValues = {
  content_configuration_type: 'creative'
}


export default {
  props: {
    isQuickContentOrderView: {},
    initialOrder: {},
    initialKeywords: {},
    sourceReport: {},
    sourceReportType: {},
    isEditMode: {},
    refreshData: {},
    projectTitle: {
      type: String,
      default: '',
    },
  },
  components: {
    ...Object.fromEntries(configComponents.map(item => [`Config${item.key}`, item.component])),
    ...Object.fromEntries(configComponents.map(item => [`ConfigPreview${item.key}`, item.previewComponent]))
  },
  data() {
    return {
      step: 0,
      packages: [],
      availableDeliveryPeriodsForSite: [],
      showAllTopLevelKeywords: false,
      showAllSupportingKeywords: false,
      ALLOWED_SILO_ORDER_DELIVERY_PERIODS: ALLOWED_SILO_ORDER_DELIVERY_PERIODS,
      SILO_ORDER_SPEEDY_DELIVERY_PERIOD: SILO_ORDER_SPEEDY_DELIVERY_PERIOD,
      SILO_ORDER_SPEEDY_DELIVERY_MULTIPLIER: SILO_ORDER_SPEEDY_DELIVERY_MULTIPLIER,
      FIRST_CONTENT_ORDER_AMOUNT_OFF: FIRST_CONTENT_ORDER_AMOUNT_OFF,

      isOpenCustomConfig: null,

      productDescription: '',
      targetAudience: '',
      sampleContent: '',
      toneOfContent: '',
      author: '',
      brand: '',
      excludeTerms: [],

      showSubAccountNotAllowedToBuyModal: false,
      order: {
        ...defaultOrderValues
      },
      keywords: [],

      modalCouponFieldValue: '',
      appliedCoupon: '',

      showBalancePaymentConfirmModal: false,
      showSendInvoiceConfirmModal: false,
      showSetPaidConfirmModal: false,

      recommendationTopState: createEmptyTopWizardState(),
      recommendationSupState: createEmptySupportingWizardState(),
      sidebarCouponExpanded: false,
    };
  },
  watch: {
    topResolvedRecommendationKey(newKey) {
      if (!this.isEditMode || this.step !== 0 || !this.topLevelKeywords.length) return;
      if (!newKey || newKey === this.order.selected_top_level_option_key) return;
      this.selectTopLevelPackage(newKey);
    },
    supportingResolvedRecommendationKey(newKey) {
      if (!this.isEditMode || this.step !== 1 || !this.supportingKeywords.length) return;
      if (!newKey || newKey === this.order.selected_supporting_option_key) return;
      this.updateOrder({ selected_supporting_option_key: newKey });
    },
    initialOrder: {
      handler(newVal) {
        this.order = {
          ...defaultOrderValues,
          ...(newVal || {})
        }
      },
      immediate: true,
    },
    initialKeywords: {
      handler(newVal) {
        this.keywords = [...(newVal || [])]
      },
      immediate: true,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    ownerUser() {
      return this.$store.state.selectedSubAccountRelation || this.$store.state.user
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    selectedSubAccountRelation() {
      return this.$store.state.selectedSubAccountRelation;
    },
    isSubAccountRelationSelected() {
      return !!this.$store.state.selectedSubAccountRelation;
    },
    effectiveCampaignId () {
      const fromRoute = parseInt(this.$route.params.campaignId || 0, 10)
      if (fromRoute) return fromRoute
      return parseInt(this.sourceReport?.campaignId || 0, 10)
    },
    isMissionControlSession () {
      return this.$store.state.selectedSubAccountRelation?.isMissionControlSubAccount
    },
    isWhiteGloveUser () {
      if (!this.user) return false;

      const accountType = this.$store.state.selectedSubAccountRelation
        ?this.$store.state.selectedSubAccountRelation.ownerAccountType
        :this.user.accountType

      if (whiteGlovePlans.includes(getPureServicePkgName(accountType))) {
        return true;
      }
      return false;
    },
    nonSpeedyDeliveryPeriods() {
      return Object.keys(ALLOWED_SILO_ORDER_DELIVERY_PERIODS).map(key => Number(key)).filter(key => key !== SILO_ORDER_SPEEDY_DELIVERY_PERIOD)
    },
    AVAILAIBLE_TOP_LEVEL_SILO_REPORTS() {
      return this.packages.filter(p => p.type === 'top_level' && !p.disabled);
    },
    AVAILAIBLE_SUPPORTING_SILO_REPORTS() {
      return this.packages.filter(p => p.type === 'supporting' && !p.disabled);
    },
    selectedTopLevelOption() {
      return this.AVAILAIBLE_TOP_LEVEL_SILO_REPORTS.filter(p => p.key === this.order.selected_top_level_option_key)[0];
    },
    selectedSupportingOption() {
      return this.AVAILAIBLE_SUPPORTING_SILO_REPORTS.filter(p => p.key === this.order.selected_supporting_option_key)[0];
    },
    topLevelKeywords() {
      return this.keywords.filter(keyword => keyword?.isTopLevelKeyword || keyword?.keywordData?.isTopLevelKeyword);
    },
    supportingKeywords() {
      return this.keywords.filter(keyword => keyword?.isSupportingKeyword || keyword?.keywordData?.isSupportingKeyword);
    },
    displayProjectTitle() {
      return (this.projectTitle || '').trim() || 'Your project';
    },
    /**
     * Edit mode: show top-level summary once step 0 is complete (Next enabled) or user has moved on.
     */
    orderSummaryRevealTopLevel() {
      if (!this.isEditMode || !this.topLevelKeywords.length) return true;
      return this.step > 0 || (this.step === 0 && this.isStepValid(0));
    },
    /**
     * Edit mode: show supporting summary once step 1 is complete (Next enabled) or user has moved on.
     */
    orderSummaryRevealSupporting() {
      if (!this.isEditMode || !this.supportingKeywords.length) return true;
      return this.step > 1 || (this.step === 1 && this.isStepValid(1));
    },
    orderSummaryLineItems() {
      const items = [];
      const topOpt = this.selectedTopLevelOption;
      const supOpt = this.selectedSupportingOption;
      if (this.orderSummaryRevealTopLevel) {
        this.topLevelKeywords.forEach((k) => {
          items.push({
            id: `t-${k.id}`,
            keyword: k.keyword,
            price: topOpt?.price,
          });
        });
      }
      if (this.orderSummaryRevealSupporting) {
        this.supportingKeywords.forEach((k) => {
          items.push({
            id: `s-${k.id}`,
            keyword: k.keyword,
            price: supOpt?.price,
          });
        });
      }
      return items;
    },
    orderArticleCount() {
      return this.topLevelKeywords.length + this.supportingKeywords.length;
    },
    orderSummaryProductLabel() {
      const parts = [];
      if (
        this.topLevelKeywords.length &&
        this.selectedTopLevelOption &&
        this.orderSummaryRevealTopLevel
      ) {
        parts.push(this.selectedTopLevelOption.label);
      }
      if (
        this.supportingKeywords.length &&
        this.selectedSupportingOption &&
        this.orderSummaryRevealSupporting
      ) {
        parts.push(this.selectedSupportingOption.label);
      }
      return parts.filter(Boolean).join(' · ') || '—';
    },
    orderSummaryDeliveryNote() {
      const days = this.order?.delivery_period_days
      const wordCount = 'Each article is 1,500–2,000 words.'
      if (days === SILO_ORDER_SPEEDY_DELIVERY_PERIOD) {
        return `Full order delivered within 72 hours (rush delivery). ${wordCount}`
      }
      const entry = days != null ? ALLOWED_SILO_ORDER_DELIVERY_PERIODS[days] : null
      if (entry) {
        return `Full order delivered within ${entry.label}. ${wordCount}`
      }
      return `${wordCount}`
    },
    topCompletedWizardRows() {
      return getCompletedTopRows(this.recommendationTopState);
    },
    supCompletedWizardRows() {
      return getCompletedSupportingRows(this.recommendationSupState);
    },
    topActiveQuestionId() {
      return getActiveTopQuestionId(this.recommendationTopState);
    },
    supActiveQuestionId() {
      return getActiveSupportingQuestionId(this.recommendationSupState);
    },
    topActiveQuestionDef() {
      const id = this.topActiveQuestionId;
      if (!id) return null;
      return Object.values(QUESTIONS).find((q) => q.id === id) || null;
    },
    supActiveQuestionDef() {
      const id = this.supActiveQuestionId;
      if (!id) return null;
      return Object.values(QUESTIONS).find((q) => q.id === id) || null;
    },
    topWizardBadgeNumber() {
      return this.topCompletedWizardRows.length + 1;
    },
    supWizardBadgeNumber() {
      return this.supCompletedWizardRows.length + 1;
    },
    topResolvedRecommendationKey() {
      if (getActiveTopQuestionId(this.recommendationTopState)) return null;
      return computeTopLevelPackageKey(this.recommendationTopState);
    },
    supportingResolvedRecommendationKey() {
      if (getActiveSupportingQuestionId(this.recommendationSupState)) return null;
      return computeSupportingPackageKey(this.recommendationSupState);
    },
    aiImagesAnyEnabled() {
      return !!this.order.generate_images_for_top_level || !!this.order.generate_images_for_supporting;
    },
    aiImageStyleOptionsList() {
      return AI_IMAGE_STYLE_OPTIONS;
    },
    totalAmountWithoutSpeedyDelivery() {
      const top = (this.selectedTopLevelOption?.price || 0) * this.topLevelKeywords.length;
      const sup = (this.selectedSupportingOption?.price || 0) * this.supportingKeywords.length;
      return top + sup;
    },
    speedyDeliveryAmount() {
      return this.totalAmountWithoutSpeedyDelivery * SILO_ORDER_SPEEDY_DELIVERY_MULTIPLIER
    },
    totalAmountBeforeDiscount() {
      let result = this.totalAmountWithoutSpeedyDelivery
      if (this.order.delivery_period_days === SILO_ORDER_SPEEDY_DELIVERY_PERIOD) {
        result += this.speedyDeliveryAmount
      }
      return result
    },
    couponAmountOff() {
      let amountOff = 0
      if (this.user.is_eligible_for_first_content_order_discount) {
        amountOff = FIRST_CONTENT_ORDER_AMOUNT_OFF
      } else if (this.appliedCoupon) {
        amountOff = this.appliedCoupon.coupon.amountOff
        if (this.appliedCoupon.coupon.couponType == 'Percent Off') {
          amountOff = (this.totalAmountBeforeDiscount * amountOff / 100)
        }
      }
      return amountOff
    },
    totalAmount() {
      return (this.totalAmountBeforeDiscount - this.couponAmountOff)
    },
    configComponents() {
      return configComponents
    },
  },
  methods: {
    formatCurrency: formatCurrency,
    selectTopLevelPackage(key) {
      const sup = this.getEquivalentPackage(key, 'supporting');
      return this.updateOrder({
        selected_top_level_option_key: key,
        ...(sup ? { selected_supporting_option_key: sup.key } : {}),
      });
    },
    topWizardPickOption(optionValue) {
      const id = this.topActiveQuestionId;
      if (!id) return;
      const s = { ...this.recommendationTopState };
      if (id === QUESTIONS.topPageType.id) {
        s.pageType = optionValue;
        s.existingTreatment = null;
        s.newFullOrOutline = null;
        s.humanReview = null;
      } else if (id === QUESTIONS.topExistingTreatment.id) {
        s.existingTreatment = optionValue;
        s.newFullOrOutline = null;
        s.humanReview = null;
      } else if (id === QUESTIONS.topNewFullOrOutline.id) {
        s.newFullOrOutline = optionValue;
        s.humanReview = null;
      } else if (id === QUESTIONS.topHumanReview.id) {
        s.humanReview = optionValue;
      }
      this.recommendationTopState = s;
    },
    topWizardChangeFromRow(rowIndex) {
      this.recommendationTopState = resetTopWizardFromStep({ ...this.recommendationTopState }, rowIndex);
    },
    supWizardPickOption(optionValue) {
      const id = this.supActiveQuestionId;
      if (!id) return;
      const s = { ...this.recommendationSupState };
      if (id === QUESTIONS.supFullOrOutline.id) {
        s.fullOrOutline = optionValue;
        s.humanReview = null;
      } else if (id === QUESTIONS.supHumanReview.id) {
        s.humanReview = optionValue;
      }
      this.recommendationSupState = s;
    },
    supWizardChangeFromRow(rowIndex) {
      this.recommendationSupState = resetSupportingWizardFromStep({ ...this.recommendationSupState }, rowIndex);
    },
    setAiImagesMaster(on) {
      const payload = {};
      if (this.topLevelKeywords.length && this.order.selected_top_level_option_key !== 'TOP_LEVEL_CONTENT_UPGRADE') {
        payload.generate_images_for_top_level = on ? 1 : 0;
      }
      if (this.supportingKeywords.length) {
        payload.generate_images_for_supporting = on ? 1 : 0;
      }
      if (!on) {
        payload.aiGeneratedImageStyle = 'none';
      } else if (!this.order.aiGeneratedImageStyle || this.order.aiGeneratedImageStyle === 'none') {
        payload.aiGeneratedImageStyle = 'photo_realistic';
      }
      this.updateOrder(payload);
    },
    selectImageStyle(style) {
      if (!this.aiImagesAnyEnabled) return;
      this.updateOrder({ aiGeneratedImageStyle: style });
    },
    reloadUser() {
      // reload user to update ui with any credit usage
      return this.$store.dispatch("loadUser").then(response => {
        this.$store.commit("setUser", response.data.user);
      });
    },
    getKeywordUrl(keyword) {
      return keyword.page || keyword.currentRankingUrl || keyword?.keywordData?.page || keyword?.keywordData?.currentRankingUrl;
    },
    isStepValid(step) {
      if (step === 0 && this.topLevelKeywords.length) {
        return (
          !this.topActiveQuestionId &&
          Boolean(this.order.selected_top_level_option_key)
        );
      }
      if (step === 0 && !this.topLevelKeywords.length) {
        return true
      }
      if (step === 1) {
        if (!this.isStepValid(step - 1)) {
          return false;
        }
        if (!this.supportingKeywords.length) {
          return true;
        }
        return (
          !this.supActiveQuestionId &&
          Boolean(this.order.selected_supporting_option_key)
        );
      }
      if (step === 2) {
        return this.isStepValid(step - 1)
      }
      if (step === 3) {
        return this.isStepValid(step - 1) && Boolean(this.order.delivery_period_days)
      }
      return false;
    },
    goBack() {
      if (this.step == 2 && !this.supportingKeywords.length) {
        this.step -= 2
      } else {
        this.step -= 1
      }
    },
    goToNextStep() {
      if (this.step == 2) {
        // configuration step
        if (this.order.content_configuration_type === 'custom') {
          this.updateOrder({
            productDescription: this.productDescription,
            targetAudience: this.targetAudience,
            sampleContent: this.sampleContent,
            toneOfContent: this.toneOfContent,
            author: this.author,
            brand: this.brand,
            excludeTerms: this.excludeTerms,
          })
        }
      }

      if (this.step == 0 && !this.supportingKeywords.length) {
        this.step += 2
      } else {
        this.step += 1
      }
    },
    getEquivalentPackage(package_key, target_type) {
      const package_key_without_prefix =  package_key.replace('TOP_LEVEL_', '').replace('SUPPORTING_', '')
      return this.packages
        .filter(p => p.type === target_type)
        .find(p => p.key.replace('TOP_LEVEL_', '').replace('SUPPORTING_', '') === package_key_without_prefix);
    },
    removeKeyword(keyword) {
      if (this?.order?.id) {
        if (keyword?.isTopLevelKeyword || keyword?.keywordData?.isTopLevelKeyword) {
          this.updateOrder({
            selected_top_level_keyword_ids: (
              this.order?.selected_top_level_keyword_ids || []
            ).filter(id => id !== keyword.id)
          })
        } else if (keyword?.isSupportingKeyword || keyword?.keywordData?.isSupportingKeyword) {
          this.updateOrder({
            selected_supporting_keyword_ids: (
              this.order?.selected_supporting_keyword_ids || []
            ).filter(id => id !== keyword.id)
          })
        }
      } else {
        this.keywords = this.keywords.filter(k => k.keyword !== keyword.keyword)
      }
    },
    bulkRemoveKeywords(keyword_type) {
      let keywords = []
      if (keyword_type === 'T') {
        keywords = [...this.topLevelKeywords]
      }
      if (keyword_type === 'S') {
        keywords = [...this.supportingKeywords]
      }

      keywords.forEach(keyword => this.removeKeyword(keyword))
    },
    createContentOrder() {
      return this.$store.dispatch('createSilo', {
        campaignId: this.effectiveCampaignId,
        name: '',
        ...this.isQuickContentOrderView
          ?{isForQuickContentOrder: 1}
          :{}
      }).then((response) => {
        const siloId = response.data.data.id

        return this.$store.dispatch('addKeywordsToSilo', {
          siloId: siloId,
          body: {
            keywords: this.keywords,
            locationCode: this.sourceReport.locationCode,
            languageCode: this.sourceReport.languageCode,
            sourceReportType: this.sourceReportType,
            sourceReportId: this.sourceReport.id,
          },
        })
        .then(() => {
          return this.$store.dispatch('getSilo', siloId)
            .then(response => {
              this.order = {
                ...response.data.data.content_report_order
              }
              return Promise.resolve()
            })
        })
      })
    },
    applyCoupon () {
      this.appliedCoupon = null;
      this.$store.commit('showLoading')
      return this.$store.dispatch('fetchValidatedCoupons', { promoCode: this.modalCouponFieldValue.trim(), isRegisterPage: 0 })
        .then((response) => {
          if (!response.data) {
            this.$notify({
              group: 'info', type: 'warning',
              text: 'Invalid coupon'
            })
            return;
          }
          if (response.data && response.data.status == 'SUCCESS') {
            let allServiceCoupons = response.data.coupons
            if (allServiceCoupons.length == 1) {
              const coupon = allServiceCoupons[0];
              if (['Percent Off', 'Amount Off'].includes(coupon.couponType) && coupon.product === 'SILO_CONTENT_REPORTS_PURCHASE_SINGLE') {
                this.appliedCoupon = {
                  code: this.modalCouponFieldValue.trim(),
                  coupon
                };
              } else {
                this.$notify({
                  group: 'info', type: 'warning',
                  text: 'Invalid coupon'
                })
              }
            } else {
              this.$notify({
                group: 'info', type: 'warning',
                text: 'Invalid coupon'
              })
            }
          } else {
            if (response.data.status == 'FAILURE') {
              this.$notify({
                group: 'info', type: 'warning',
                text: response.data.errorMsg ? response.data.errorMsg : 'Invalid coupon'
              })
            }
          }
        })
        .finally(() => {
          this.$store.commit('hideLoading')
        })
    },
    buyNow(mode='checkout') {
      if (
        this.isSubAccountRelationSelected &&
        !(this.isMissionControlSession && mode === 'invoice')
      ) {
        this.showSubAccountNotAllowedToBuyModal = true
        return
      }

      this.$store.commit('showLoading');
      return this.$store.dispatch('createStripePayment', {
        packageType: 'SILO_CONTENT_REPORTS_PURCHASE',
        userID: this?.selectedSubAccountRelation?.ownerId || this.user.id,
        items: [
          {
            'type': this.isQuickContentOrderView ? 'quick_content_order': 'silo_order',
            'id': this.order.id
          }
        ],
        mode,
        promoCode: this.appliedCoupon?.code
      })
      .then((response) => {
        if (response.data && response.data.url) {
          window.open(response.data.url, '_self')
        } else if (mode === 'balance' && response.data.status === 'SUCCESS') {
          this.$notify({
            group: 'info', type: 'success',
            text: 'Purchase successful'
          })
          this.showBalancePaymentConfirmModal = false
          return this.refreshData()
            .then(() => this.reloadUser())
            .then(() => {
              this.$emit('close');
            })
        } else if (mode === 'invoice' && response.data.status === 'SUCCESS') {
          this.$notify({
            group: 'info', type: 'success',
            text: 'Invoice sent to user'
          })
          this.showSendInvoiceConfirmModal = false
        }
      })
      .finally(() => {
        this.$store.commit('hideLoading');
      })
    },
    updateOrder(payload) {
      this.$store.commit('showLoading');
      return this.$store.dispatch('updateSiloContentReportOrder', {
        orderId: this.order.id,
        body: payload
      })
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          if (payload.set_in_cart || payload.set_paid) {
            // wait for 1 second before redirecting
            setTimeout(() => {
              const { siteId } = this.$route.params
              this.$store.commit('triggerRefreshSiloContentReportsOrdersCart', true);

              if (['ContentOnlyDetailWhiteGlove', 'ContentPlanDetailWhiteGlove'].includes(this.$route.name) && this.$route.params.siloId && Number(this.$route.params.siloId) === response.data.order.siloId) {
                this.refreshData()
              } else {
                if (this.isQuickContentOrderView) {
                  this.$router.push(`/sites/${siteId}/all-content/quick/${response.data.order.siloId}`);
                } else {
                  this.$router.push(`/sites/${siteId}/content-plans/${response.data.order.siloId}`);
                }
              }
              this.$emit('close');
            }, 1000);
          } else {
            this.order = {
              ...response.data.order,
            }
            this.refreshData()
          }
        }
      })
      .finally(() => {
        this.$store.commit('hideLoading');
      })
    },
    countWords(value) {
      return value?.split?.(' ')?.filter?.(x => x !== '')?.length || 0
    },
    addNewExcludeTerm(termsStr) {
      termsStr = termsStr.trim().toLowerCase();
      if (!termsStr) {
        return;
      }
      const excludeTerms = this.excludeTerms.slice();

      let terms = termsStr.split(",").map((item) => item.trim());

      terms.map((term) => {
        if (!excludeTerms.includes(term)) {
          excludeTerms.push(term);
        }
      });
      this.excludeTerms = excludeTerms;
    },
    handleRemoveExcludeTerm(p) {
      this.excludeTerms = this.excludeTerms.filter((term) => term != p);
    },
  },
  mounted () {

    if (!this.topLevelKeywords.length) {
      this.step = 1
    }

    this.$store.commit('showLoading')
    this.$store.dispatch('getAvailableSiloContentReportPackages')
    .then(response => {
      if (response.data && response.data.status == 'SUCCESS') {
        this.packages = response.data.packages;
        return Promise.resolve()
      }
    })
    .then(() => this.$store.dispatch('getAvailableSiloContentReportDeliveryOptionsForSite', {
      siteId: this.$route.params.siteId,
      ...this.isQuickContentOrderView
        ?{isForQuickContentOrder: 1}
        :{}
    }))
    .then(response => {
      if (response.data && response.data.status == 'SUCCESS') {
        this.availableDeliveryPeriodsForSite = response.data.availableDeliveryPeriods;
        return Promise.resolve()
      }
    })
    .then(() => {
      if (!this?.order?.id) {
        return this.createContentOrder()
      } else {
        return Promise.resolve()
      }
    })
    .then(() => {
      if (this?.order?.content_configuration_type === 'custom') {
        this.productDescription = this.order.productDescription
        this.targetAudience = this.order.targetAudience
        this.sampleContent = this.order.sampleContent
        this.toneOfContent = this.order.toneOfContent
        this.author = this.order.author
        this.brand = this.order.brand
        this.excludeTerms = this.order.excludeTerms
      }

      const defaultValues = {}
      if (!this.order.selected_top_level_option_key) {
        defaultValues.selected_top_level_option_key = this.AVAILAIBLE_TOP_LEVEL_SILO_REPORTS[0].key
      }
      if (!this.order.selected_supporting_option_key) {
        defaultValues.selected_supporting_option_key = this.AVAILAIBLE_SUPPORTING_SILO_REPORTS[0].key
      }
      if (Object.entries(defaultValues).length) {
        return this.updateOrder(defaultValues)
      }
      return Promise.resolve()
    })
    .finally(() => {
      this.$store.commit('hideLoading')
    })
  }
};
</script>

<style lang="scss" scoped>
@import './styles.scss';

.sales-tag-dropdown {
  .dropdown-item {
    font-weight: normal;
  }

  &.is-disabled {
    opacity: initial;
    cursor: default;
  }
}

.sales-tag-btn {
  text-transform: initial;
  letter-spacing: initial;
}
</style>
